export { default } from './AppVersion'
